"use client";

import dynamic from "next/dynamic";

const LandingApp = dynamic(() => import("@/components/landing-app"), {
  ssr: false,
});

export function LandingAppLoader() {
  return <LandingApp />;
}
